import a from "./ghl-ui.es1472.js";
import e from "./ghl-ui.es1475.js";
var r = e(a);
const t = r;
export {
  t as default
};
